import { useWinnersCtx } from "@/contexts/winners";
// import { SubCategoryFilter } from "./sub-category-filter";
import { useTranslation } from "@/i18n/client";
import { YearFilter } from "./year-filter";
import { MobileItems } from "./top-bar";

export default function TitleContent() {
  const { category, lang } = useWinnersCtx();
  const { t } = useTranslation(lang, "winners");
  return (
    <div className="flex flex-col justify-between gap-10 pb-20 xs:flex-row xs:items-center">
      <div className="flex flex-col gap-2">
        <p className="text-lg opacity-40 lg:text-lg xl:text-xl ltr:font-sans">
          {t("Winners")}
        </p>
        <h2 className="text-3xl text-secondary xl:text-3xl ltr:font-playfair ltr:-tracking-[0.03em]">
          {category.title}
        </h2>
      </div>
      <div className="flex flex-col gap-6 sm:flex-row sm:justify-between">
        {/* <SubCategoryFilter /> */}
        <MobileItems />
        <YearFilter />
      </div>
    </div>
  );
}
